<template>
  <div class="vertical-gap">
&nbsp;
  </div>
</template>

<style lang="scss" scoped>
.vertical-gap {
    height: 12px;
}
</style>
